import React, { useState, useEffect } from 'react';
import Cards from '../common/Cards';
import { LifeStyle, LightBrownTick, OrangeTick, YourGoals } from '../assets/svg';

interface LifeStyleAndGoalsProps {
  LifeStyleAndGoalsData: {
    lifeStyle: string[];
    goals: string[];
  };
}

const LifeStyleAndGoals: React.FC<LifeStyleAndGoalsProps> = ({ LifeStyleAndGoalsData }) => {
  const { lifeStyle, goals } = LifeStyleAndGoalsData;
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const HandleRemoveBulletPoint = (text: string) => {
    return text.replace(/^•\s*/, '').trim();
  };
  return (
    <>
      <section id="lifestyle-and-goals" data-pdf-section>
        <div className="flex items-center flex-col md:flex-row gap-[30px] lg:gap-[40px]">
          {Array.isArray(lifeStyle) && lifeStyle.length > 0 ? (
            <div
              className="w-full h-full"
              style={{ height: isDesktop ? '-webkit-fill-available' : 'auto' }}
            >
              <Cards p="p-[20px] md:p-30px" border="#E8E8E8">
                <div>
                  <LifeStyle />
                </div>
                <div className="mt-[15px] md:mt-[13.8px] text-[18px] font-semibold leading-[normal]">
                  Student Current Lifestyle
                </div>
                <div className="h-[1px] bg-[#F3EFEB] mt-[15px] mb-[20px] md:mt-[20px] md:mb-[25px]" />
                <article className="flex gap-[18px] flex-col">
                  {lifeStyle.map((items, index) => {
                    return (
                      <div key={index} className="flex gap-[10px]">
                        <div>
                          <LightBrownTick />
                        </div>
                        <div className="text-[14.5px] font-medium leading-[normal] text-[#7B5636]">
                          {HandleRemoveBulletPoint(items)}
                        </div>
                      </div>
                    );
                  })}
                </article>
              </Cards>
            </div>
          ) : null}
          {Array.isArray(goals) && goals.length > 0 ? (
            <div
              className="w-full h-full"
              style={{ height: isDesktop ? '-webkit-fill-available' : 'auto' }}
            >
              <Cards p="p-[20px] md:p-30px md:pr-[24px] h-[inherit]" border="#F1DFD0" bg="#FFF8F2">
                <div>
                  <YourGoals />
                </div>
                <div className="mt-[15px] md:mt-[13.8px] text-[18px] font-semibold leading-[normal]">
                  Student Goals
                </div>
                <div className="h-[1px] bg-[#EEE5DD] mt-[15px] mb-[20px] md:mt-[20px] md:mb-[25px]" />
                <article className="flex gap-[18px] flex-col">
                  {goals.map((items, index) => {
                    return (
                      <div key={index} className="flex gap-[10px]">
                        <div>
                          <OrangeTick />
                        </div>
                        <div className="text-[13px] md:text-[14.5px] font-medium leading-[normal] text-[#622A00]">
                          {HandleRemoveBulletPoint(items)}
                        </div>
                      </div>
                    );
                  })}
                </article>
              </Cards>
            </div>
          ) : null}
        </div>
      </section>
    </>
  );
};

export default LifeStyleAndGoals;
